import { useEffect, useRef, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import CircularProgress from "@mui/material/CircularProgress";
import { Header } from "../Header";
import { MenuComponent } from "../Menu";
import { Outlet, useLocation } from "react-router-dom";
import { useAllocation } from "../../externalComponent/hooks/useAllocations";
import styles from "./syles.module.scss";

const PrivateRoute = () => {
  const { keycloak, initialized } = useKeycloak();
  const [toggledMenuMobile, setToggledMenuMobile] = useState(false);
  const mainRef = useRef<HTMLDivElement>(null);

  const {
    searchResource,
    areaSelected,
    clientSelected,
    projectSelected,
    positionSelected,
    costCenterSelected,
  } = useAllocation();

  const location = useLocation();
  const pathAtual = location.pathname;

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      keycloak.login();
    }
  }, [initialized, keycloak]);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTop = 0;
    }
  }, [
    searchResource,
    areaSelected,
    clientSelected,
    projectSelected,
    positionSelected,
    costCenterSelected,
  ]);

  if (!initialized) {
    return (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress size={100} />
      </div>
    );
  }

  return (
    <>
      {initialized && (
        <>
          <Header
            setToggleMenuMobile={setToggledMenuMobile}
            toggledMenuMobile={toggledMenuMobile}
          />
          <div className={styles.wrapper}>
            <MenuComponent
              setToggleMenuMobile={setToggledMenuMobile}
              toggledMenuMobile={toggledMenuMobile}
            />
            <main
              ref={mainRef}
              className={`${pathAtual === "/scheduler" && styles.notPadding}`}
            >
              {keycloak.authenticated ? <Outlet /> : null}
            </main>
          </div>
        </>
      )}
    </>
  );
};

export default PrivateRoute;
